// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__u+pvu","address":"Contact_address__oSS0G","form":"Contact_form__XC6cd","inner":"Contact_inner__RxtAf","button":"Contact_button__a970k"};